import { useAppDispatch } from '@/app/hooks';
import { ButtonComponent } from '@/components/Button/Button';
import { clearQuery, initialState } from '@/features/filterSlice';
import { useTrackFilterChange } from '@/views/filter/useTrackFilterChange';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import type { StackProps } from '@mantine/core';
import { Box, Stack } from '@mantine/core';

export function ClearFilter(props: StackProps) {
  const intl = useClientTerminology();
  const dispatch = useAppDispatch();
  const trackFilterChange = useTrackFilterChange();

  return (
    <Stack style={{ order: 2 }} align="start" {...props}>
      <Box>
        {intl.formatMessage({
          id: 'list.noResultsWithActiveFilters',
        })}
      </Box>
      <ButtonComponent
        id="clear-button"
        data-testid="clear-filter-button"
        variant="secondary"
        label={intl.formatMessage({ id: 'list.clearFilterButton' })}
        onClick={() => {
          dispatch(clearQuery());
          trackFilterChange(initialState, 'no_results');
        }}
      />
    </Stack>
  );
}
